/** Курс связан с компетенцией: `GET /courses` отдаёт компетенции объектами, а не id. */
export const hasCompetency = (
  course: { competencyIds?: (string | { _id: string })[] },
  competencyId: string,
) =>
  !!course.competencyIds?.some((ref) => (typeof ref === 'string' ? ref : ref._id) === competencyId);
